import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderTop from './HeaderTop';
import Sidebar from './Sidebar';
import AssistantChatWidget from './AssistantChatWidget';
import { SidebarProvider, useSidebar } from '../shared/SidebarContext';

function LayoutInner() {
  const { collapsed } = useSidebar();

  return (
    <div className={`page${collapsed ? ' sidebar-collapsed' : ''}`}>
      <Sidebar />
      <div className="app-main">
        <HeaderTop />
        <div className="page-wrapper">
          <Outlet />
        </div>
      </div>
      <AssistantChatWidget />
    </div>
  );
}

function Layout() {
  return (
    <SidebarProvider>
      <LayoutInner />
    </SidebarProvider>
  );
}

export default Layout;
